import { ReactNode, useRef } from 'react'

interface Props {
  // 受控开关；首次为 true 后 children 保持挂载
  open: boolean
  children: ReactNode
}

// 首次 open=true 才挂载 children（配合 next/dynamic 延迟加载 chunk），
// 之后即使 open=false 也保持挂载，把显隐与退场动画交给内层组件的 open prop。
const LazyMount = ({ open, children }: Props) => {
  const hasOpenedRef = useRef(false)
  if (open) hasOpenedRef.current = true
  return hasOpenedRef.current ? <>{children}</> : null
}

export default LazyMount
